import {css} from 'lit';

import {defaultStyles} from '../../../components/skeleton.js';

export const styles = defaultStyles.extends({
  statics: css``,
  radiusGen: () => '',
});

export default {styles};
